import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Company } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private _http:HttpClient) { }

  getCompanyDetail(id:any){
    return this._http.get('company/' + id + '/')
  }
  editCompany(company:Company , id:any){
    const formData: FormData = new FormData();
    if(company.logo){
      formData.append('logo', company.logo);
    }
    formData.append('name', company.name);
    formData.append('url', company.url.toString());
    formData.append('owner_first_name', company.owner_first_name);
    formData.append('owner_last_name', company.owner_last_name);
    formData.append('owner_phone_number', company.owner_phone_number.toString()); // Assuming phone_number is a string, adjust if necessary
    formData.append('owner_email', company.owner_email);
    // formData.append('financial_info',parseInt( company.financial_info)); // Assuming financial_info is a string, adjust if necessary
    formData.append('is_owner', company.is_owner.toString());
    formData.append('file_type', company.file_type);
   
   
    return this._http.put('company/' + id + '/',formData)
  }
  
}
